import type { ButtonColor } from './colors';

export const primaryColors: Partial<Record<ButtonColor, string>> = {
  brand: 'bg-primary text-primary-foreground hover:bg-brand-primary-800',
  white:
    'bg-white font-semibold text-text-accent-700 focus-visible:ring-white focus-visible:ring-offset-black hover:bg-white/90',
  destructive: 'bg-destructive text-text-inverse hover:bg-destructive/90',
};
